import { Center } from '@mantine/core'
import { forwardRef } from 'react'
import type { Props } from '../node/definition'

export default forwardRef((p: Props) => {
	return (
		<Center {...p} {...p.customProps}>
			{p.children}
		</Center>
	)
})
